import { Brand } from "../types";

const basePath = process.env.PUBLIC_URL || "";

export const brands: Brand[] = [
  {
    id: 1,
    name: "VEKA",
    logo: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/logos_1/svg_veka-diamond_logo.svg",
    description: "VEKA Polska jest producentem systemów profili okiennych, systemów drzwi przesuwnych oraz rolet z tworzyw sztucznych. Od 1994 roku jesteśmy obecni na polskim rynku budowlanym. Siedziba firmy mieści się w Skierniewicach.Z małego regionalnego przedsiębiorstwa staliśmy się światowym liderem na rynku systemów profili okiennych i drzwiowych z PVC.Jakość profili VEKA jest znana wśród producentów okien, architektów, inwestorów.",
    descriptionKey: "brands.veka.description",
    link: "https://www.veka.pl/startowa/",
    sections: [
      {
        id: 100,
        title: "Okna",
        titleKey: "brands.veka.sections.windows.title",
        description:
          "Okna to niezwykle ważny element elewacji budynku. Doświetlają pomieszczenia, chronią przed czynnikami zewnętrznymi, jak wiatr, deszcz, śnieg. Zapewniają przyjemny mikroklimat we wnętrzach. Dobre okna z profilami wysokiej jakości, jak VEKA, mają bardzo istotne znaczenie dla właściwego bilansu energetycznego budynku. Energooszczędne okna to konieczny nieodzowny element w nowoczesnym budownictwie.VEKA oferuje różne systemy okienne z PVC, spełniające wszelkie wymagania techniczne i projektowe. Jakość VEKA zapewnia wieloletnią niezawodność funkcjonowania okien.",
        descriptionKey: "brands.veka.sections.windows.description",
        images: [
          {
            id: 101,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/fenster_softline_82_ad_haus_4_res_1_1_w700.jpg",
            descriptionModal:
              "Nowoczesne okna z systemami profili SOFTLINE 82 AD optymalizują bilans energetyczny budynku. Są energooszczędne, trwałe, stabilne i bezpieczne. Nawet w dużych konstrukcjach profile SOFTLINE 82 AD mogą być wąskie, co jest walorem zarówno dla nowoczesnej architektury, jak i stylowej renowacji. SOFTLINE 82 AD jest wyposażony w dwie uszczelki przylgowe.",
            name: "SOFTLINE 82 AD",
            descriptionKey: "brands.veka.images.101.description",
            descriptionModalKey: "brands.veka.images.101.descriptionModal",
            link: "https://www.veka.pl/systemy-okienne/softline-82-ad/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_82_ad/technische_details_softline_82_ad_1080x975.jpg",
            description:
              "Najwyższa jakość! VEKA oferuje wyłącznie profile najwyższej klasy A (zgodnie z normą PN-EN 12608). Grubość ścianek zewnętrznych profili wynosi 3 mm (z tolerancją 0,2 mm).",
          },
          {
            id: 102,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_82_md/fenster_softline_82_md_haus_6_res_1_1_w700.jpg",
            descriptionModal:
              "System profili SOFTLINE 82 MD może być stosowany do produkcji energooszczędnych, nowoczesnych okien z PVC, które optymalizują bilans energetyczny każdego budynku. To doskonały wybór do domów niskoenergetycznych i pasywnych. Profile SOFTLINE 82 MD charakteryzują się wyjątkową trwałością, stabilnością i bezpieczeństwem.",
            name: "SOFTLINE 82 MD",
            descriptionKey: "brands.veka.images.102.description",
            descriptionModalKey: "brands.veka.images.102.descriptionModal",
            link: "https://www.veka.pl/systemy-okienne/softline-82-md/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_82_md/technische_details_softline_82_md_1080x975.jpg",
            description:
              "Głęboka wnęka na szybę Pakiet szybowy osadza się w profilu na dużej głębokości, czyli 25 mm, dzięki czemu okno ma lepsze właściwości cieplne i jest mniej narażone na wykraplanie się pary wodnej.",
          },
          {
            id: 103,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_76_ad/fenster_softline_76_ad_haus_3_res_1_1_w700.jpg",
            descriptionModal:
              "Dzięki głębokości podstawy wynoszącej 76 mm profile SOFTLINE 76 AD łączą zalety systemów 70 i 82 mm, będąc rozwiązaniem ekonomicznym i zarazem wpływającym na efektywność energetyczną budynku. Pomagają obniżyć koszty ogrzewania domu. Chronią przed zimnem, hałasem i wilgocią.W profilach SOFTLINE 76 AD można montować pakiety szybowe m.in. o podwyższonej izolacyjności akustycznej i odporności na włamanie.",
            name: "SOFTLINE 76 AD",
            descriptionKey: "brands.veka.images.103.description",
            descriptionModalKey: "brands.veka.images.103.descriptionModal",
            link: "https://www.veka.pl/systemy-okienne/softline-76-ad/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_76_ad/technische_details_softline_76_ad_1080x975.jpg",
            description:
              "Najwyższa jakość! VEKA oferuje wyłącznie profile najwyższej klasy A (zgodnie z normą PN-EN 12608). Grubość ścianek zewnętrznych profili wynosi 3 mm (z tolerancją 0,2 mm).",
          },
          {
            id: 104,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_76_md/fenster_softline_76_md_haus_3_res_1_1_w700.jpg",
            descriptionModal:
              "Profile SOFTLINE 76 MD posiadają trzy poziomy uszczelniania z uszczelką centralną, skutecznie chroniąc przed hałasem, zimnem, wilgocią i przeciągami. Jako system wielokomorowy o głębokości podstawy 76 mm łączy zalety systemów 70 i 82 mm, zapewniając idealną równowagę między energią a efektywnością kosztową. Można z nich konstruować nawet duże przeszklenia.W profilach SOFTLINE 76 MD można montować pakiety szybowe m.in. o podwyższonej izolacyjności akustycznej i odporności na włamanie.",
            name: "SOFTLINE 76 MD",
            descriptionKey: "brands.veka.images.104.description",
            descriptionModalKey: "brands.veka.images.104.descriptionModal",
            link: "https://www.veka.pl/systemy-okienne/softline-76-md/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_76_md/technische_details_softline_76_md_1080x975.jpg",
            description:
              "Najwyższa jakość! VEKA oferuje wyłącznie profile najwyższej klasy A (zgodnie z normą PN-EN 12608). Grubość ścianek zewnętrznych profili wynosi 3 mm (z tolerancją 0,2 mm).",
          },
          {
            id: 105,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_70/fenster_softline_70_ad_haus_1_res_1_1_w700.jpg",
            descriptionModal:
              "Dzięki nowoczesnym oknom PVC wykonanym z profili VEKA każdy dom jest wyjątkowy. Klasyczny design profili SOFTLINE 70 AD i PERFECTLINE, z lekko zaokrąglonymi konturami jest ponadczasowy i doskonale komponuje się z szeroką gama stylów architektonicznych, nowoczesnych lub tradycyjnych, nowych lub remontowanych.",
            name: "SOFTLINE 70 AD",
            descriptionKey: "brands.veka.images.105.description",
            descriptionModalKey: "brands.veka.images.105.descriptionModal",
            link: "https://www.veka.pl/systemy-okienne/softline-70-ad/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/01_fenster/softline_70/technische_details_softline_70_ad_1080x975.jpg",
            description:
              "Najwyższa jakość! VEKA oferuje wyłącznie profile najwyższej klasy A (zgodnie z normą PN-EN 12608). Grubość ścianek zewnętrznych profili wynosi 3 mm (z tolerancją 0,2 mm).",
          },
        ],
      },

      {
        id: 200,
        title: "Systemy drzwi przesuwnych ",
        titleKey: "brands.veka.sections.sliding_doors.title",
        description:
          "Wybierz jeden z naszych systemów drzwi podnoszono-przesuwnych. Systemy oparte na nowoczesnych technologiach umożliwiają konstruowanie dużych przeszkleń przy zastosowaniu wąskich profili.",
        descriptionKey: "brands.veka.sections.sliding_doors.description",
        images: [
          {
            id: 201,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/vekamove-exterieur-700x700_res_1_1_w700.jpg",
            description:
              "Przebadane przez VEKA rozwiązania konstrukcyjne gwarantują bezpieczeństwo w wielu aspektach m.in. wysoką odporność na próby włamania.",
            name: "VEKAMOVE 76",
            descriptionKey: "brands.veka.images.201.description",
            descriptionModalKey: "brands.veka.images.201.descriptionModal",
            link: "https://www.veka.pl/systemy-drzwi-przesuwnych/vekamove-76/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/technische_details_vekamove-76-390x260-4_res_3_2_w390_res_3_2_w390.png",
            descriptionModal:
              "Wraz z rosnącym zapotrzebowaniem na rozwiązania zapewniające oszczędność miejsca, coraz ważniejsze staje się optymalne wykorzystanie dostępnej przestrzeni. Drzwi przesuwne VEKAMOVE 76 są energooszczędną odpowiedzią na to wyzwanie. Nadają wnętrzom każdej wielkości przyjazną i przestronną atmosferę.",
          },
          {
            id: 202,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/vekamove-exterieur-700x700_res_1_1_w700.jpg",
            description:
              "Zapewniają doskonałą izolacyjność termiczną. Współczynnik przenikania ciepła dla drzwi tarasowych Ud to nawet 0,78 W/(m²K), przy Ug = 0,5 W/(m²K), ψg = 0,031 W/(mK) (wymiary elementu 3,5 x 2,3 m).",
            name: "VEKAMOTION 82",
            descriptionKey: "brands.veka.images.202.description",
            descriptionModalKey: "brands.veka.images.202.descriptionModal",
            link: "https://www.veka.pl/systemy-drzwi-przesuwnych/vekamotion-82/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/schiebetueren/vekamotion_82/technische_details_vekamotion_82_390x260_3_res_3_2_w390.jpg",
            descriptionModal:
              "VEKAMOTION 82 to system oparty na nowoczesnych technologiach, umożliwiający konstruowanie drzwi o dużych gabarytach, przy jednoczesnym zastosowaniu wąskich profili. VEKAMOTION 82 jest konstrukcją, która spełnia najwyższe wymagania architektów, wykonawców i inwestorów. Dzięki nowemu progowi z PVC w systemie VEKAMOTION 82 przejście może być bezprogowe, przy zachowaniu maksymalnej efektywności energetycznej.",
          },
          {
            id: 203,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/schiebetueren/vekamotion_82_max/vekamotion_max_res_1_1_w700.jpg",
            description:
              "Zapewniają doskonałą izolacyjność termiczną. Współczynnik przenikania ciepła dla drzwi tarasowych Ud to nawet 0,73 W/(m²K), przy Ug = 0,5 W/(m²K), ψg = 0,031 W/(mK) (wymiary elementu 3,5 x 2,3 m).",
            name: "VEKAMOTION 82 MAX",
            descriptionKey: "brands.veka.images.203.description",
            descriptionModalKey: "brands.veka.images.203.descriptionModal",
            link: "https://www.veka.pl/systemy-drzwi-przesuwnych/vekamotion-82-max/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/schiebetueren/vekamotion_82_max/technische_details_vekamotion_82_max_390x260_3_res_3_2_w390.jpg",
            descriptionModal:
              "System tarasowy podnoszono-przesuwny VEKAMOTION 82 MAX to innowacyjne rozwiązanie zabudowy tarasowej. Daje możliwość konstruowania bardzo dużych przeszkleń w wąskich profilach. W wariancie VEKAMOTION 82 MAX jest dostępne skrzydło stałe z wyjątkowo wąskim profilem PVC. Rama może być niemal całkowicie otynkowana, co od strony elewacji daje wrażenie przeszkleń bezramowych. Dzięki temu efektownemu rozwiązaniu system VEKAMOTION 82 MAX został wyróżniony nagrodą Red Dot Design Award.",
          },
        ],
      },
      {
        id: 300,
        title: "Rolety",
        titleKey: "brands.veka.sections.shutters.title",
        description:
          "Nasze rolety zewnętrzne są wykonane z wysokiej jakości tworzywa sztucznego, odpornego na uderzenia i trudne warunki atmosferyczne. Gwarantują wysoką stabilność i dobrą izolacyjność.",
        descriptionKey: "brands.veka.sections.shutters.description",
        images: [
          {
            id: 301,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/fensterbauer/fensterhersteller_rolllaeden_slider_res_2_1_w800.jpg",
            name: "VEKAVARIANT 2.0",
            descriptionKey: "brands.veka.images.301.description",
            descriptionModalKey: "brands.veka.images.301.descriptionModal",
            description:
              "Może być zamontowany na dole lub z przodu, dzięki czemu można go łatwo otworzyć bez użycia narzędzi, nawet jeśli skrzynka jest otynkowana od wewnątrz.",
            descriptionModal:
              "System VEKAVARIANT 2.0 spełnia wszystkie wymagania stawiane nowoczesnym skrzynkom roletowym. VEKAVARIANT 2.0 jest dostępny w trzech różnych rozmiarach. Gwarantuje doskonałą izolację termiczną. Skrzynka nadstawna jest nie tylko idealnym uzupełnieniem wszystkich okien w systemach VEKA, ale nadaje się również do łączenia z systemami okiennymi innych znanych producentów. VEKAVARIANT 2.0 może być stosowany do każdego rodzaju otworu i sytuacji montażowej. Umożliwia także montaż moskitier. Ponadto dostępna jest również specjalna skrzynka VEKAVARIANT EPS (Grupor), zapewniająca najlepszą izolację akustyczną i cieplną.",
            link: "https://www.veka.pl/rolety/vekavariant-2-0/",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/sichtschutz/vekavariant_eps/vekavariant_eps_700x700_res_1_1_w801.jpg",
          },
          {
            id: 302,
            src: "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/bauherren_rollladen_2_res_1_1_w700.jpg",
            name: "Lamele do rolet VEKA",
            descriptionKey: "brands.veka.images.302.description",
            descriptionModalKey: "brands.veka.images.302.descriptionModal",
            description: "",
            descriptionModal:
              "VEKA oferuje szeroką gamę profili do wysokiej jakości rolet zewnętrznych, odpornych nawet na ekstremalne warunki pogodowe. Lamele roletowe nadają się do różnorodnych zastosowań i wymagań.",
            link: "Lamele do rolet VEKA",
            srcModal:
              "https://vekaprod-media.e-spirit.cloud/b6252b26-67a1-48c1-945f-18c997221746/editorial_media/produkte/sichtschutz/vekavariant_eps/vekavariant_eps_700x700_res_1_1_w801.jpg",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Martom",
    logo: `${basePath}/images/martom.png`,
    description:
      "Drzwi są wizytówką naszego domu. Stanowią zapowiedź tego, co jest wewnątrz. Są ambasadorem i równocześnie strażnikiem ogniska domowego. Zanim przekroczy się próg domu, ma się do czynienia właśnie z nimi. To drzwi witają naszych gości.",
    descriptionKey: "brands.martom.description",
    link: "https://drzwimartom.pl/",
    sections: [
      {
        id: 400,
        title: "Oferta Martom",
        titleKey: "brands.martom.sections.offer.title",
        description:
          "Współpracujemy z firmą Martom. Kliknij w przycisk i zobacz oferte ze strony firmy Martom",
        descriptionKey: "brands.martom.sections.offer.description",
        images: [
          {
            id: 401,
            src: "https://drzwimartom.pl/wp-content/uploads/2022/09/Drzwi-zewnętrzne.png",
            name: "Martom",
            descriptionKey: "brands.martom.images.401.description",
            descriptionModalKey: "brands.martom.images.401.descriptionModal",
            description: "Dlaczego wybrać drzwi firmy Martom.",
            descriptionModal: "Kliknij przycisk aby przejść do strony",
            link: "https://drzwimartom.pl/",
            srcModal:
              "https://drzwimartom.pl/wp-content/uploads/2022/09/Budowa-drzwi-zewnętrznych-MARTOM.jpeg",
          },
        ],
      },
    ],
  },
];
